export default "/images/vendor/@coreui/icons/svg/flag/cif-tz.svg?0a01765312047b1272bc1d0290db9ff3";